import React, { useCallback, useEffect, useMemo, useState } from "react"
import { CSSTransition } from "react-transition-group"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import { i18n } from "@/utils/i18n"
import GAME_GIFT_DICT from "../../../data/gift"
import { useGameStore } from "../../../store"
import { IGameGift } from "../../../type"
import { SFX } from "../../../utils/sound"
import { getTransitionClassnames } from "../../../utils/transition"
import Button from "../../Button"
import {
    useGameAddressModal,
    useGameModalStore,
    useGameRuleModal,
} from "../store"

import styles from "./index.module.less"

const RollModal: StyledComponent = ({ className, style }) => {
    const [active, setActive] = useState(false)
    useEffect(() => {
        useGameModalStore.setState({
            callRollModal: () => {
                setActive(true)
            },
        })
    }, [])
    const callRuleModal = useGameRuleModal()
    const callAddressModal = useGameAddressModal()
    const rollResult = useGameStore((state) => state.rollResult)
    const address = useGameStore((state) => state.address)
    const gift = useMemo<IGameGift | undefined>(
        () =>
            rollResult.bingo
                ? GAME_GIFT_DICT[rollResult.giftKey]
                : GAME_GIFT_DICT.default,
        [rollResult]
    )
    const handleBack = useCallback(() => {
        SFX.play("commonClick")
        setActive(false)
    }, [])
    return (
        <CSSTransition
            in={active}
            timeout={300}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                className={classNames(styles.rollModal, className)}
                style={style}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <div className={styles.deco}>
                    <div
                        className={classNames(
                            styles.topDeco,
                            rollResult.bingo && styles.award
                        )}
                    ></div>
                    <div className={styles.handLeft}></div>
                    <div className={styles.handRight}></div>
                </div>
                <div className={styles.middleFrame}>
                    <div
                        className={classNames(
                            styles.cnDeco,
                            rollResult.bingo && styles.award
                        )}
                    ></div>
                    <div className={styles.frame}></div>
                    <div
                        className={classNames(
                            styles.giftImage,
                            gift?.key === "default" && styles.small
                        )}
                        style={{
                            backgroundImage: gift
                                ? `url(${gift.image})`
                                : undefined,
                        }}
                    ></div>
                    <div className={styles.enDeco}>CONGRATULATIONS</div>
                    <div className={styles.title}>
                        <div className={styles.cn}>{gift?.name}</div>
                        <div className={styles.en}>SPECIAL GIFT</div>
                    </div>
                </div>

                <div className={styles.buttonGroup}>
                    <Button
                        size="small"
                        active={false}
                        onClick={() => {
                            SFX.play("commonClick")
                            callRuleModal()
                        }}
                    >
                        {i18n(i18nData, "rogue_4.game.roll.rule")}
                    </Button>
                    <Button size="small" active={false} onClick={handleBack}>
                        {i18n(i18nData, "rogue_4.game.roll.back")}
                    </Button>
                    {rollResult.bingo && (
                        <Button
                            className={'check-check'}
                            size="small"
                            active={false}
                            onClick={() => {
                                SFX.play("commonClick")
                                callAddressModal()
                            }}
                        >
                            {address
                                ? i18n(
                                      i18nData,
                                      "rogue_4.game.roll.viewAddress"
                                  )
                                : i18n(
                                      i18nData,
                                      "rogue_4.game.roll.inputAddress"
                                  )}
                        </Button>
                    )}
                </div>
                {/* <div className={styles.backButton} onClick={handleClose}></div> */}
            </div>
        </CSSTransition>
    )
}

export default RollModal
